import type { QueryClient } from '@tanstack/react-query';

import { notificationsQueryKeys } from '@/modules/notifications/queries/queryKeys';
import type { NotificationsApi } from '@/modules/notifications/types';

/**
 * Marks matching notifications read in the cached list before the request
 * lands, so unread dots clear on click instead of after the refetch. Returns
 * the rollback for `onError`.
 */
export async function markReadInCache(
  queryClient: QueryClient,
  isTarget: (notification: NotificationsApi) => boolean,
) {
  const queryKey = notificationsQueryKeys.list();
  // A refetch already in flight would overwrite the optimistic rows.
  await queryClient.cancelQueries({ queryKey });
  const previous = queryClient.getQueryData<NotificationsApi[]>(queryKey);
  const readUtc = new Date().toISOString();
  queryClient.setQueryData<NotificationsApi[]>(queryKey, (notifications) =>
    notifications?.map((notification) =>
      !notification.readUtc && isTarget(notification)
        ? { ...notification, readUtc }
        : notification,
    ),
  );
  return () => queryClient.setQueryData(queryKey, previous);
}
